import angular from 'angular';
import accountSettingsModule from '../accountSettingsModule';
import twoStepVerificationConstants from "./../constants/twoStepVerificationConstants";

function accountSettingsModalTwoStepController(
  $scope,
  $uibModalInstance,
  accountsService,
  modalData,
  modalService,
  modalConstantsService
) {
  'ngInject';

  angular.extend($scope, modalData);
  $scope.twoStepInfo = {};
  $scope.doesPasswordExist = modalData.doesPasswordExist;

  $scope.layout = {
    isUpdateTwoStepBusy: false,
    isInitialized: false
  };

  $scope.twoStepErrorMessage = function(form) {
    if ($scope.error) {
      return $scope.error;
    }
    return null;
  };

  $scope.init = function() {
    if (!$scope.layout.isInitialized) {
      $scope.twoStepIsSet = false;
      $scope.layout.isInitialized = true;
      $scope.layout.isUpdateTwoStepBusy = false;
    }
  };

  $scope.submit = function(form) {
    if (form.$valid) {
      form.$setPristine();
      $scope.error = null;
      $scope.layout.isUpdateTwoStepBusy = true;
      if (!$scope.doesPasswordExist) {
        $scope.twoStepInfo.password = 'placeholder';
      }

      accountsService.disableTwoStepVerification(twoStepVerificationConstants.mediaTypes.email, $scope.twoStepInfo.password).then(() => {
        $scope.twoStepIsSet = true;
        $scope.error = null;
        $scope.dismiss();
      }).catch(error => {
        $scope.twoStepIsSet = false;
        $scope.error = error.message;
      });
      
      $scope.layout.isUpdateTwoStepBusy = false;
    }
  };

  $scope.dismiss = function() {
    if ($scope.twoStepIsSet) {
      $scope.error = null;
      $uibModalInstance.close(true);
    } else {
      $uibModalInstance.dismiss();
    }
  };

  $scope.init();
}

accountSettingsModule.controller(
  'accountSettingsModalTwoStepController',
  accountSettingsModalTwoStepController
);

export default accountSettingsModalTwoStepController;
